var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.36497 1.36431C2.31601 0.905113 1.94826 0.5 1.43527 0.5C0.883666 0.5 0.5 0.968383 0.5 1.46875V2.25V7.8457V8.8125V10.5312C0.5 11.0316 0.883666 11.5 1.43527 11.5C1.98687 11.5 2.37054 11.0316 2.37054 10.5312V8.96119L3.45701 8.66831L3.45715 8.66828C4.07717 8.50094 4.73482 8.57796 5.3115 8.8875C6.24281 9.38898 7.32871 9.45149 8.30585 9.05535C8.30602 9.05528 8.3062 9.05521 8.30637 9.05514L8.93484 8.80157L8.93543 8.80134C9.36578 8.62708 9.625 8.20083 9.625 7.75195V2.29102C9.625 1.52863 8.83788 0.899223 8.07545 1.30976L7.90134 1.40351L7.90095 1.40373C7.20948 1.77686 6.39962 1.77688 5.70814 1.4038L2.36497 1.36431ZM2.36497 1.36431L3.28184 1.11688L3.28244 1.11672C4.09775 0.897786 4.95991 0.999798 5.70801 1.40373L2.36497 1.36431Z",
    fill: "#D67D00",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flag-icon.f737edab3bcfcb2e88efec5a5d7251a5.svg";
export { ForwardRef as ReactComponent };